import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const uiModule = namespace('ui');
let HomePage = class HomePage extends Vue {
    constructor() {
        super(...arguments);
        this.book = 0;
    }
    get books() {
        return [
            {
                to: 'rules/phb',
                title: 'The Player\'s Handbook',
                image: 'phb_cover',
                subText: 'The Player\'s Handbook mirrors the traditional 5th edition Player\'s Handbook, with some deviations for playing in the Star Wars Universe.'
            },
            {
                to: 'rules/snv',
                title: 'Scum and Villainy',
                image: 'sav_cover',
                subText: 'Scum and Villainy includes a menagerie of Star Wars-themed monsters and villains.'
            },
            {
                to: 'rules/sotg',
                title: 'Starships of the Galaxy',
                image: 'sotg_cover',
                subText: 'Starships of the Galaxy features rules governing spaceships, space adventuring, and space combat.'
            },
            {
                to: 'rules/wh',
                title: 'Wretched Hives',
                image: 'wh_cover',
                subText: 'Wretched Hives adds rules for new downtime activities, running factions, and introduces enhanced items.'
            }
        ];
    }
    get sitePages() {
        return [
            {
                to: 'rules',
                title: 'Rules',
                icon: 'fa-journal-whills',
                subText: 'The four books, broken down by chapter, as well as a link to some SW5e variant rules.'
            },
            {
                to: 'characters',
                title: 'Characters',
                icon: 'fa-users',
                subText: 'Everything you need for your character, from fighting styles to force powers.'
            },
            {
                to: 'loot',
                title: 'Loot',
                icon: 'fa-toolbox',
                subText: 'Grab your blaster, a nice suit of armor, a few thermal detonators, and take on the galaxy! Also, check out the tab for enhanced items.'
            },
            {
                to: 'starships',
                title: 'Starships',
                icon: 'fa-rocket',
                subText: 'Just like the characters tab, but for your ship. Hyperdrives, quad-cannons, and navicomputers -- it\'s all here.'
            },
            {
                to: 'tools',
                title: 'Tools',
                icon: 'fa-edit',
                subText: 'Create your character right here on the SW5e website! (Currently in development)'
            },
            {
                to: 'assets',
                title: 'Assets',
                icon: 'fa-file-download',
                subText: 'Downloadable pdfs, character sheets, podcasts and more.'
            },
            {
                to: 'credits',
                title: 'Credits',
                icon: 'fa-list',
                subText: 'A comprehensive list of contributors to the SW5e project.'
            }
        ];
    }
    get socialLinks() {
        return [
            {
                title: 'Development',
                channels: [
                    {
                        href: 'https://discord.gg/zYcPYTu',
                        icon: 'fab fa-discord',
                        title: 'Discord'
                    }
                ],
                subText: 'Discord is where the development occurs. If you have questions that you\'ve otherwise not been able to find answers to, or you want to develop content for Star Wars 5e, this is the place to do it.'
            },
            {
                title: 'Connect',
                channels: [
                    {
                        href: 'https://www.reddit.com/r/sw5e',
                        icon: 'fab fa-reddit',
                        title: 'Reddit'
                    },
                    {
                        href: 'https://twitter.com/Galiphile',
                        icon: 'fab fa-twitter',
                        title: 'Twitter'
                    },
                    {
                        href: 'https://www.facebook.com/groups/starwars5e',
                        icon: 'fab fa-facebook',
                        title: 'Facebook'
                    }
                ],
                subText: 'These three channels are used for sharing Star Wars 5e content, questions, and more.'
            },
            {
                title: 'Support',
                channels: [
                    {
                        href: 'https://www.patreon.com/noble_delta_squad_dev_team',
                        icon: 'fab fa-patreon',
                        title: 'Patreon'
                    }
                ],
                subText: 'The Patreon is set up to cover the costs of this website. It supports Delta Squad, the team that manages this site and n7.world, a Mass Effect 5e conversion. As a Patron, you can choose to have your contribution go towards this site, n7.world, or both.'
            }
        ];
    }
    get themeToggleColor() {
        return this.isDarkSide ? this.$vuetify.theme.themes.light.secondary : this.$vuetify.theme.themes.dark.background;
    }
    toggleDarkSideTheme() {
        this.$vuetify.theme.dark = !this.isDarkSide;
        this.toggleDarkSide(!this.isDarkSide);
    }
};
__decorate([
    uiModule.State
], HomePage.prototype, "isDarkSide", void 0);
__decorate([
    uiModule.Action
], HomePage.prototype, "toggleDarkSide", void 0);
HomePage = __decorate([
    Component
], HomePage);
export default HomePage;
